<template>
  <Transition name="fade-transform" mode="out-in">
    <div v-if="show" class="action-popover z-20" @click.stop>
      <slot />
    </div>
  </Transition>
</template>

<script>
export default {
  name: 'ActionPopover',
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  watch: {
    show(newVal) {
      if (newVal) setTimeout(() => this.addClickListener(), 0);
      else this.removeClickListener();
    },
  },
  mounted() {
    if (this.show) this.addClickListener();
  },
  beforeDestroy() {
    this.removeClickListener();
  },
  methods: {
    hide() {
      this.$emit('hide');
    },
    addClickListener() {
      document.body.addEventListener('click', this.hide);
    },
    removeClickListener() {
      document.body.removeEventListener('click', this.hide);
    },
  },
};
</script>

<style lang="scss">
.action-popover {
  position: absolute;
  top: 0;
  left: 0;
  @include rtl() {
    right: 0;
    left: auto;
  }

  background-color: #fff;

  border-radius: $lb-border-radius * 2;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}
</style>
